//商品渠道
export const platformType_status = [
  { label: "淘宝", value: "0", color: "" },
  { label: "1688", value: "1", color: "" },
  { label: "京东", value: "2", color: "" },
  { label: "拼多多", value: "3", color: "" },
  { label: "天猫", value: "4", color: "" },
];
export const returnStatus = (status, _status = [], key = "label") => {
  if (!status) {
    return;
  }
  const value = _status.find((item) => item.value == status);
  if (value) {
    return value[key];
  } else {
    return;
  }
};
